const es = {
  header: {
    badge: "Guía Oficial de BotMix",
    title: "Widget de Chat Web",
    summary:
      "Personaliza e instala un botón flotante de chat en vivo en tu sitio web. Permite a tus visitantes comunicarse contigo directamente por WhatsApp o chat web en tiempo real.",
  },
  sections: [
    {
      id: "personalizacion_widget",
      title: "1. Personalización Visual del Widget",
      description:
        "Ajuste de colores, mensaje de bienvenida, posición y texto de llamada a la acción.",
      items: [
        {
          id: "colores_estilos",
          title: "Colores y Apariencia",
          definition:
            "Elige colores de fondo, icono flotante, alineación a la derecha o izquierda y estilo del botón de inicio.",
        },
        {
          id: "mensajes_bienvenida",
          title: "Mensaje de Bienvenida",
          definition:
            "Define el saludo inicial que verá el visitante invitándolo a iniciar una conversación con tu equipo.",
        },
      ],
    },
    {
      id: "codigo_instalacion",
      title: "2. Instalación en el Sitio Web",
      description:
        "Generación del código JavaScript para insertar en tu página o plataforma web.",
      items: [
        {
          id: "snippet_js",
          title: "Código de Inserción",
          definition:
            "Copia y pega el fragmento de código HTML/JS antes del cierre de la etiqueta </body> en tu sitio web.",
        },
      ],
    },
  ],
};

const en = {
  header: {
    badge: "BotMix Official Guide",
    title: "Web Chat Widget",
    summary:
      "Customize and embed a floating live chat widget on your website. Empower visitors to message your support team directly via WhatsApp or real-time web chat.",
  },
  sections: [
    {
      id: "personalizacion_widget",
      title: "1. Visual Customization",
      description:
        "Color palette, greeting message, screen positioning, and call-to-action text.",
      items: [
        {
          id: "colores_estilos",
          title: "Colors & Design",
          definition:
            "Choose background colors, floating icons, right/left screen alignment, and button styling.",
        },
        {
          id: "mensajes_bienvenida",
          title: "Greeting Prompt",
          definition:
            "Set the initial prompt inviting visitors to begin a conversation with your support agents.",
        },
      ],
    },
    {
      id: "codigo_instalacion",
      title: "2. Website Installation",
      description:
        "JavaScript snippet ready to be added to your website or CMS.",
      items: [
        {
          id: "snippet_js",
          title: "Embed Code Snippet",
          definition:
            "Copy and paste the HTML/JS script before the closing </body> tag of your website.",
        },
      ],
    },
  ],
};

const pt = {
  header: {
    badge: "Guia Oficial BotMix",
    title: "Widget de Chat Web",
    summary:
      "Personalize e instale um botão flutuante de chat ao vivo em seu site. Permita que seus visitantes entrem em contato direto via WhatsApp ou chat web.",
  },
  sections: [
    {
      id: "personalizacion_widget",
      title: "1. Personalização Visual",
      description:
        "Cores, mensagem de recepção, posicionamento e chamada para ação.",
      items: [
        {
          id: "colores_estilos",
          title: "Cores e Aparência",
          definition:
            "Ajuste a paleta de cores, ícone flutuante e alinhamento na tela (esquerda ou direita).",
        },
        {
          id: "mensajes_bienvenida",
          title: "Mensagem de Boas-vindas",
          definition:
            "Defina o texto inicial convidando o visitante para conversar com a equipe.",
        },
      ],
    },
    {
      id: "codigo_instalacion",
      title: "2. Instalação no Site",
      description:
        "Código JavaScript pronto para incorporar em sua página.",
      items: [
        {
          id: "snippet_js",
          title: "Código de Incorporação",
          definition:
            "Copie e cole o script antes do fechamento da tag </body> do seu site.",
        },
      ],
    },
  ],
};

const fr = {
  header: {
    badge: "Guide Officiel BotMix",
    title: "Widget de Chat Web",
    summary:
      "Personnalisez et intégrez un bouton flottant de discussion sur votre site. Donnez à vos visiteurs l'accès direct à votre équipe via WhatsApp ou chat en direct.",
  },
  sections: [
    {
      id: "personalizacion_widget",
      title: "1. Personnalisation Visuelle",
      description:
        "Couleurs, message de bienvenue, positionnement et incitation au contact.",
      items: [
        {
          id: "colores_estilos",
          title: "Thème et Couleurs",
          definition:
            "Choisissez les couleurs, l'icône flottante et l'alignement sur l'écran (gauche ou droite).",
        },
        {
          id: "mensajes_bienvenida",
          title: "Message d'Accueil",
          definition:
            "Rédigez l'amorce invitant l'utilisateur à démarrer l'échange avec un conseiller.",
        },
      ],
    },
    {
      id: "codigo_instalacion",
      title: "2. Intégration sur le Site",
      description:
        "Extrait de code JavaScript à intégrer dans vos pages web.",
      items: [
        {
          id: "snippet_js",
          title: "Code d'Intégration",
          definition:
            "Copiez et collez le script avant la balise de fermeture </body> de votre site web.",
        },
      ],
    },
  ],
};

const ar = {
  header: {
    badge: "دليل BotMix الرسمي",
    title: "أداة الدردشة للموقع (Web Widget)",
    summary:
      "خصص وثبّت زر دردشة عائم على موقعك الإلكتروني. يتيح لزوار الموقع التواصل المباشر معك عبر واتساب أو الدردشة المباشرة.",
  },
  sections: [
    {
      id: "personalizacion_widget",
      title: "1. التخصيص البصري للأداة",
      description:
        "الألوان، رسالة الترحيب، الموضع ونصوص الحث على التواصل.",
      items: [
        {
          id: "colores_estilos",
          title: "الألوان والمظهر",
          definition:
            "حدد ألوان الخلفية والأيقونة العائمة وموضع الظهور (يمين أو يسار الشاشة).",
        },
        {
          id: "mensajes_bienvenida",
          title: "رسالة الترحيب",
          definition:
            "اكتب عبارة الترحيب التي تظهر للزائر لتشجيعه على بدء محادثة مع الفريق.",
        },
      ],
    },
    {
      id: "codigo_instalacion",
      title: "2. التثبيت في الموقع",
      description:
        "كود جافاسكريبت جاهز للنسخ والتضمين في موقعك.",
      items: [
        {
          id: "snippet_js",
          title: "كود التضمين",
          definition:
            "انسخ كود البرمجة والصقه قبل وسم الإغلاق </body> في موقعك الإلكتروني.",
        },
      ],
    },
  ],
};

export const WEB_WIDGET_HELP_DATA = { es, en, pt, fr, ar };
export default WEB_WIDGET_HELP_DATA;
